<template>
  <div class="row">
    <div>
      <api-header :id="id" class="capitalize" tag="h4">
        <i18n-t keypath="documentation.api.parameters.title" tag="span" scope="global">
          <template #type>
            {{ $t(`documentation.api.parameters.${type}`) }}
          </template>
        </i18n-t>
      </api-header>
      <div v-for="(parameter, index) in parameters" :key="parameter.name + index">
        <api-schema-property
          v-if="parameter.schema"
          :parameter="parameter.name"
          :schema="parameter.schema"
          :required="type === 'path'"
        >
          <template #description>
            <html-text tag="span" :html="parameter.description" />
          </template>
        </api-schema-property>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { ParameterObject } from '@bifrost-dev-docs-mfe/common/types/apiDocs';
import HtmlText from '@/components/utils/HtmlText.vue';
import ApiHeader from '@/components/api/content/common/ApiHeader.vue';
import ApiSchemaProperty from '@/components/api/content/operations/schema/ApiSchemaProperty.vue';

defineProps({
  id: { type: String, required: true },
  type: { type: String, required: true },
  parameters: { type: Array as PropType<ParameterObject[]>, required: true },
});
</script>
